/* eslint-disable */
/**
 * DO NOT EDIT THIS FILE
 */
import { KinesisTracker } from '@weberus/client-tracker';
import type { Sorting } from '../module/yanolja_standardcode_search/sorting';
import type { GPlaceFilter } from '../module/yanolja_clientlog_custom_productlist/g-place-filter';
import type { RoomPeople } from '../module/yanolja_standardcode/room-people';
import type { CommonItemLogMetaPriceDto } from '../module/yanolja_clientlog_cx/common-item-log-meta-price-dto';
import type { CommonItemLogMetaProductDto } from '../module/yanolja_clientlog_cx/common-item-log-meta-product-dto';
import type { CommonItemLogMetaReviewDto } from '../module/yanolja_clientlog_cx/common-item-log-meta-review-dto';
import type { CommonItemLogMetaBadgeDto } from '../module/yanolja_clientlog_cx/common-item-log-meta-badge-dto';
import type { ExpMeta } from '../module/yanolja_clientlog_experiment/exp-meta';
import type { MemberClassType } from '../module/yanolja_standardcode/member-class-type';

/**
 * PageName: G_PLACE_LIST
 */
export const GPlaceListPageLog = {
  SearchResultPropertyIdMaster: {
    /**
     * SRP(해외숙소) - 상품 노출
     * 스크린샷: https://screen.yanolja.in/fdCpFZkZpkcgqXcl.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search_result/common.txtpb#L4}
     * GlobalHotelSearchResult
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/search.proto#L64}
     */
    impression({
      keyword,
      checkInDate,
      checkOutDate,
      sorting,
      listStamp,
      gPlaceFilter,
      roomPeople,
      priceGroup,
      productGroup,
      reviewGroup,
      badgeGroup,
      position,
      resultCount,
      expMeta,
      badgeMemberCode,
      priceType,
      globalStayPriceMemberCode,
      isCuratedListProperty,
      transactionId,
      propertyMasterId,
    }: GPlaceListPageLog.SearchResultPropertyIdMaster.Impression) {
      return KinesisTracker.impression('G_PLACE_LIST', {
        clientEventId: 291,
        pageName: 'PAGE_NAME_G_PLACE_LIST',
        object: propertyMasterId,
        objectContainer: 'SearchResult',
        objectType: 'OBJECT_TYPE_PROPERTY_ID',
        eventType: 'EVENT_TYPE_IMPR',
        keyword,
        checkInDate,
        checkOutDate,
        sorting,
        listStamp,
        gPlaceFilter,
        roomPeople,
        priceGroup,
        productGroup,
        reviewGroup,
        badgeGroup,
        position,
        resultCount,
        expMeta,
        badgeMemberCode,
        priceType,
        globalStayPriceMemberCode,
        isCuratedListProperty,
        transactionId,
      });
    },

    /**
     * SRP(해외숙소) - 상품 클릭
     * 스크린샷: https://screen.yanolja.in/gEcino0tuDkRMDBA.png
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search_result/common.txtpb#L19}
     * GlobalHotelSearchResult
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/search.proto#L64}
     */
    click({
      keyword,
      checkInDate,
      checkOutDate,
      sorting,
      listStamp,
      gPlaceFilter,
      roomPeople,
      priceGroup,
      productGroup,
      reviewGroup,
      badgeGroup,
      position,
      resultCount,
      expMeta,
      badgeMemberCode,
      priceType,
      globalStayPriceMemberCode,
      isCuratedListProperty,
      transactionId,
      propertyMasterId,
    }: GPlaceListPageLog.SearchResultPropertyIdMaster.Click) {
      return KinesisTracker.click('G_PLACE_LIST', {
        clientEventId: 292,
        pageName: 'PAGE_NAME_G_PLACE_LIST',
        object: propertyMasterId,
        objectContainer: 'SearchResult',
        objectType: 'OBJECT_TYPE_PROPERTY_ID',
        eventType: 'EVENT_TYPE_CLICK',
        keyword,
        checkInDate,
        checkOutDate,
        sorting,
        listStamp,
        gPlaceFilter,
        roomPeople,
        priceGroup,
        productGroup,
        reviewGroup,
        badgeGroup,
        position,
        resultCount,
        expMeta,
        badgeMemberCode,
        priceType,
        globalStayPriceMemberCode,
        isCuratedListProperty,
        transactionId,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace GPlaceListPageLog {
  export namespace SearchResultPropertyIdMaster {
    /**
     * 스크린샷: https://screen.yanolja.in/fdCpFZkZpkcgqXcl.png
     */
    export interface Impression {
      /* 검색어.*/
      keyword: string;
      /* 체크인 일자.*/
      checkInDate: string;
      /* 체크아웃 일자.*/
      checkOutDate: string;
      /* 정렬.*/
      sorting?: Sorting;
      /* 로그 전송 시점. (iOS의 경우 클라이언트에서 직접 전송, Android/web 은 서버드리븐 방식으로 전송)*/
      listStamp: string;
      /* 해외숙소 상세 필터.*/
      gPlaceFilter?: GPlaceFilter[];
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 가격 노출 정보.*/
      priceGroup: CommonItemLogMetaPriceDto;
      /* 숙소 노출 정보.*/
      productGroup: CommonItemLogMetaProductDto;
      /* 후기 노출 정보.*/
      reviewGroup: CommonItemLogMetaReviewDto;
      /* 할인 뱃지 정보.*/
      badgeGroup: CommonItemLogMetaBadgeDto;
      /* SRP 내 상품 위치. https://screen.yanolja.in/xhNSPS4qSMMEcLLL*/
      position: number;
      /* 검색 결과 카운트.*/
      resultCount: number;
      /* 실험메타 정보.*/
      expMeta?: ExpMeta;
      /*
       * 회원등급제 뱃지 노출 정보.
       *1. 뱃지 노출시 &gt; 회원 등급 정보(global_stay_price_member_code와 동일한 값)
       *2. 뱃지 미노출시 &gt; NULL
       */
      badgeMemberCode?: MemberClassType;
      /*
       * 객실 요금제 정보.
       *1. B2C 요금 &gt; B2C
       *2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT)
       */
      priceType: string;
      /*
       * 회원 등급 정보.
       *항공구매 &gt; FLIGHT_01 / 골드 &gt; LEVEL_01 / 일반 &gt; LEVEL_00 / 비회원 &gt; NULL
       */
      globalStayPriceMemberCode: string;
      /* 큐레이션된 숙소목록에서 제공된 숙소인지 여부. 큐레이션된 숙소목록에서 제공된 경우 True, 그렇지 않은 경우 False*/
      isCuratedListProperty?: boolean;
      /* joy API로 request한 정보를 unique하게 식별하는 id.*/
      transactionId: string;
      propertyMasterId: string;
    }

    /**
     * 스크린샷: https://screen.yanolja.in/gEcino0tuDkRMDBA.png
     */
    export interface Click {
      /* 검색어.*/
      keyword: string;
      /* 체크인 일자.*/
      checkInDate: string;
      /* 체크아웃 일자.*/
      checkOutDate: string;
      /* 정렬.*/
      sorting?: Sorting;
      /* 로그 전송 시점. (iOS의 경우 클라이언트에서 직접 전송, Android/web 은 서버드리븐 방식으로 전송)*/
      listStamp: string;
      /* 해외숙소 상세 필터.*/
      gPlaceFilter?: GPlaceFilter[];
      /* 객실 정보.*/
      roomPeople?: RoomPeople[];
      /* 가격 노출 정보.*/
      priceGroup: CommonItemLogMetaPriceDto;
      /* 숙소 노출 정보.*/
      productGroup: CommonItemLogMetaProductDto;
      /* 후기 노출 정보.*/
      reviewGroup: CommonItemLogMetaReviewDto;
      /* 할인 뱃지 정보.*/
      badgeGroup: CommonItemLogMetaBadgeDto;
      /* SRP 내 상품 위치. https://screen.yanolja.in/xhNSPS4qSMMEcLLL*/
      position: number;
      /* 검색 결과 카운트.*/
      resultCount: number;
      /* 실험메타 정보.*/
      expMeta?: ExpMeta;
      /*
       * 회원등급제 뱃지 노출 정보.
       *1. 뱃지 노출시 &gt; 회원 등급 정보(global_stay_price_member_code와 동일한 값)
       *2. 뱃지 미노출시 &gt; NULL
       */
      badgeMemberCode?: MemberClassType;
      /*
       * 객실 요금제 정보.
       *1. B2C 요금 &gt; B2C
       *2. B2B 요금 &gt; 회원 등급별로 다른 값(골드 회원 &gt; B2B / 항공구매 회원 &gt; FLIGHT)
       */
      priceType: string;
      /*
       * 회원 등급 정보.
       *항공구매 &gt; FLIGHT_01 / 골드 &gt; LEVEL_01 / 일반 &gt; LEVEL_00 / 비회원 &gt; NULL
       */
      globalStayPriceMemberCode: string;
      /* 큐레이션된 숙소목록에서 제공된 숙소인지 여부. 큐레이션된 숙소목록에서 제공된 경우 True, 그렇지 않은 경우 False*/
      isCuratedListProperty?: boolean;
      /* joy API로 request한 정보를 unique하게 식별하는 id.*/
      transactionId: string;
      propertyMasterId: string;
    }
  }
}

/**
 * PageName: G_PLACE_MAP
 */
export const GPlaceMapPageLog = {
  Search: {
    /**
     * 해외숙소 지도 - 전체 지면 - 뷰
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search_result/common.txtpb#L34}
     * undefined
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom_from_api/product_list/common.proto#L0}
     */
    view({ logMeta }: GPlaceMapPageLog.Search.View) {
      return KinesisTracker.view('G_PLACE_MAP', {
        clientEventId: 651,
        pageName: 'PAGE_NAME_G_PLACE_MAP',
        objectContainer: 'search',
        eventType: 'EVENT_TYPE_VIEW',
        ...logMeta,
      });
    },
  },

  SearchResultPropertyIdMaster: {
    /**
     * 지도(해외숙소) - 상품 노출
     * 스크린샷: https://screen.yanolja.in/gAx20CoYdG0R5TFE.png
     *지도에서 보기는 SRP와 동일한 로그를 전달하고 있음 > 통합검색 로깅 데이터로 변경
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search_result/common.txtpb#L44}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    impression({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      propertyMasterId,
    }: GPlaceMapPageLog.SearchResultPropertyIdMaster.Impression) {
      return KinesisTracker.impression('G_PLACE_MAP', {
        clientEventId: 293,
        pageName: 'PAGE_NAME_G_PLACE_MAP',
        object: propertyMasterId,
        objectContainer: 'SearchResult',
        objectType: 'OBJECT_TYPE_PROPERTY_ID',
        eventType: 'EVENT_TYPE_IMPR',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },

    /**
     * 지도(해외숙소) - 상품 클릭
     *
     * txtpb
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/resources/clientlogs/search_result/common.txtpb#L61}
     * ProductListProductCommonClient
     * @see {@link https://github.com/yanolja-org/infra-protobuf/blob/main/yanolja/clientlog/custom/productlist/misc.proto#L13}
     */
    click({
      position,
      roomPeople,
      sourcePage,
      locationInfo,
      selectedKeyword,
      logMeta,
      propertyMasterId,
    }: GPlaceMapPageLog.SearchResultPropertyIdMaster.Click) {
      return KinesisTracker.click('G_PLACE_MAP', {
        clientEventId: 294,
        pageName: 'PAGE_NAME_G_PLACE_MAP',
        object: propertyMasterId,
        objectContainer: 'SearchResult',
        objectType: 'OBJECT_TYPE_PROPERTY_ID',
        eventType: 'EVENT_TYPE_CLICK',
        position,
        roomPeople,
        sourcePage,
        locationInfo,
        selectedKeyword,
        ...logMeta,
      });
    },
  },
};

/**
 * 자동생성된 로그 전송 타입
 */
export namespace GPlaceMapPageLog {
  export namespace Search {
    /**
     */
    export interface View {
      /* 서버 로그 바이패스*/
      logMeta?: any;
    }
  }
  export namespace SearchResultPropertyIdMaster {
    /**
     * 스크린샷: https://screen.yanolja.in/gAx20CoYdG0R5TFE.png
     *지도에서 보기는 SRP와 동일한 로그를 전달하고 있음 > 통합검색 로깅 데이터로 변경
     */
    export interface Impression {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      propertyMasterId: string;
    }

    /**
     */
    export interface Click {
      /* 광고, 일반 상품일 경우 리스트에서 위치한 상품 순서. 해외숙소 지도 관련 로그(client_event_id: 293, 294)에서는 남기지 않음)*/
      position?: number;
      /* 객실 정보*/
      roomPeople?: RoomPeople[];
      /**
       * * 국내숙소 ***
       *if($listName=OldStation) 경우 진입 경로를 의미함.
       */
      sourcePage?: string;
      /* 리스트 상의 지역정보 문구 (예: plp에서 지역카테고리명, 내주변 리스트에서 &#34;송파구 올림픽로 35가길&#34;, 단 검색 키워드는 제외)*/
      locationInfo?: string;
      /* 나열된 연관 검색어에서 클릭된 검색어*/
      selectedKeyword?: string;
      /* 서버 로그 바이패스*/
      logMeta?: any;
      propertyMasterId: string;
    }
  }
}
